module.exports = __webpack_public_path__ + "img/newsletter-icon-subscribe-newsletter.74129aee.png";